import * as React from 'react';

interface Props {
  errors: Error[];
}

export const Errors: React.FC<Props> = (props) => {
  const { errors } = props;

  if (errors.length === 0) {
    return null;
  }
  return (
    <div className="font-medium text-red-900">
      {errors.map((e, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i}>
          {e.name} {e.message}
        </div>
      ))}
    </div>
  );
};
